var _rect, _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.1154H38.4C39.218 14.1154 40.0052 14.4486 40.5876 15.0459C41.1704 15.6436 41.5 16.457 41.5 17.3077V33.3077C41.5 34.1584 41.1704 34.9717 40.5876 35.5695C40.0052 36.1668 39.218 36.5 38.4 36.5H9.6C8.78197 36.5 7.99481 36.1668 7.41242 35.5695C6.8296 34.9717 6.5 34.1584 6.5 33.3077V8.69231C6.5 7.84163 6.8296 7.02826 7.41242 6.4305C7.99481 5.83317 8.78197 5.5 9.6 5.5H22.5168C23.0905 5.49999 23.6538 5.66379 24.1437 5.97428C24.6336 6.28485 25.0313 6.73034 25.2906 7.26218L26.944 10.6538H12C11.545 10.6538 11.1113 10.8394 10.7935 11.1653C10.4761 11.4908 10.3 11.9296 10.3 12.3846C10.3 12.8396 10.4761 13.2785 10.7935 13.604C11.1113 13.9299 11.545 14.1154 12 14.1154Z",
    fill: "url(#paint0_linear_23663_24468)",
    stroke: "url(#paint1_radial_23663_24468)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_23663_24468)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 47C49.732 47 56 40.732 56 33C56 25.268 49.732 19 42 19C34.268 19 28 25.268 28 33C28 40.732 34.268 47 42 47Z",
    fill: "url(#paint2_linear_23663_24468)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 47C49.732 47 56 40.732 56 33C56 25.268 49.732 19 42 19C34.268 19 28 25.268 28 33C28 40.732 34.268 47 42 47Z",
    fill: "url(#paint3_radial_23663_24468)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5 33C55.5 40.4558 49.4558 46.5 42 46.5C34.5442 46.5 28.5 40.4558 28.5 33C28.5 25.5442 34.5442 19.5 42 19.5C49.4558 19.5 55.5 25.5442 55.5 33Z",
    stroke: "url(#paint4_radial_23663_24468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5 33C55.5 40.4558 49.4558 46.5 42 46.5C34.5442 46.5 28.5 40.4558 28.5 33C28.5 25.5442 34.5442 19.5 42 19.5C49.4558 19.5 55.5 25.5442 55.5 33Z",
    stroke: "url(#paint5_radial_23663_24468)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_23663_24468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1782 47.7899C30.2739 46.6941 30.2739 44.9176 29.1782 43.8218C28.0824 42.7261 26.3059 42.7261 25.2101 43.8218L17.8218 51.2101C16.7261 52.3059 16.7261 54.0824 17.8218 55.1782C18.9176 56.2739 20.6941 56.2739 21.7899 55.1782L29.1782 47.7899Z",
    fill: "url(#paint6_linear_23663_24468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1782 47.7899C30.2739 46.6941 30.2739 44.9176 29.1782 43.8218C28.0824 42.7261 26.3059 42.7261 25.2101 43.8218L17.8218 51.2101C16.7261 52.3059 16.7261 54.0824 17.8218 55.1782C18.9176 56.2739 20.6941 56.2739 21.7899 55.1782L29.1782 47.7899Z",
    fill: "url(#paint7_radial_23663_24468)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8246 47.4363C29.7251 46.5359 29.7251 45.0759 28.8246 44.1754C27.9241 43.2749 26.4641 43.2749 25.5637 44.1754L18.1754 51.5637C17.2749 52.4641 17.2749 53.9241 18.1754 54.8246C19.0759 55.7251 20.5359 55.7251 21.4363 54.8246L28.8246 47.4363Z",
    stroke: "url(#paint8_radial_23663_24468)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8246 47.4363C29.7251 46.5359 29.7251 45.0759 28.8246 44.1754C27.9241 43.2749 26.4641 43.2749 25.5637 44.1754L18.1754 51.5637C17.2749 52.4641 17.2749 53.9241 18.1754 54.8246C19.0759 55.7251 20.5359 55.7251 21.4363 54.8246L28.8246 47.4363Z",
    stroke: "url(#paint9_radial_23663_24468)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_23663_24468",
    x: 22,
    y: 13,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_23663_24468"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_23663_24468",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_23663_24468",
    x: 11,
    y: 37,
    width: 25,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_23663_24468"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_23663_24468",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23663_24468",
    x1: 6,
    y1: 5,
    x2: 20.8454,
    y2: 38.4021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_23663_24468",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.69231 -10.3846) rotate(52.3297) scale(39.65 41.11)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_23663_24468",
    x1: 28.875,
    y1: 18.0345,
    x2: 50.4088,
    y2: 48.8476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_23663_24468",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.875 18.0345) scale(26.25 36.6897)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_23663_24468",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.75 32.0345) rotate(37.113) scale(19.2019 19.8097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_23663_24468",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.75 16.1034) rotate(122.39) scale(11.4341 11.0091)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_23663_24468",
    x1: 31.4944,
    y1: 45.2258,
    x2: 20.2702,
    y2: 40.7439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F09C9C",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6D7F0",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_23663_24468",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.4944 45.2258) rotate(-135) scale(5.26098 24.5109)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_23663_24468",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.7489 52.7073) rotate(156.628) scale(8.32649 6.11665)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_23663_24468",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.3065 41.2135) rotate(124.225) scale(6.56602 2.56688)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.6faac6205e34ce8c6fa522140619848e.svg";
export { ForwardRef as ReactComponent };